import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "@babel/polyfill";
import { Provider } from "react-redux";
import configureStore from "../common/config/configureStore";
import Root from "./containers/Root";

const store = configureStore();

export class MiniCartApp extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		return (
			<Router>
				<Provider store={store}>
					<Root readOnly={false} />
				</Provider>
			</Router>
		);
	}
}

const elem = document.getElementById("miniCartApp");
ReactDOM.render(<MiniCartApp />, elem);
